module.exports = __webpack_public_path__ + "static/media/vu.4e86dc8b.svg";